import React, { useCallback, useEffect } from 'react'
import AnimatedLoader from '../shared_components/AnimatedLoader'
import { Box } from '../shared_components/UI/Box'
import { toast } from 'react-toastify'
import { FullPageContainer, useRefetchUpdateUser } from './TwitterAuth'
import queryString from 'query-string'
import { useHistory } from 'react-router-dom'

const { REACT_APP_DISCORD_REDIRECT_URL: DISCORD_REDIRECT_URL } = process.env

const DiscordAuth = () => {
  const history = useHistory()
  const refetchUpdateUser = useRefetchUpdateUser()
  const verifyAndRedirect = useCallback(
    async (launchedFrom: string) => {
      try {
        const hasSuccessfullyRefetched = await refetchUpdateUser()
        if (!hasSuccessfullyRefetched) throw new Error('Failed to refetch user')
        toast.success('Discord connected successfully YO')
        history.replace(launchedFrom, { skipHistoryUpdate: true })
      } catch (error) {
        console.error(error)
        toast.error('Failed to connect Discord')
      }
    },
    [history, refetchUpdateUser],
  )

  useEffect(() => {
    try {
      const code = window.location.href.split('?code=')[1]
      const success = window.location.href.split('?success=')[1]
      const launchedFrom = localStorage.getItem('launched_from')
      const queries = queryString.parse(window.location.search)
      const { error } = queries

      if (!!success && success === 'true') {
        if (!launchedFrom) throw new Error('No launched from')
        localStorage.removeItem('launched_from')
        verifyAndRedirect(launchedFrom)
        return
      }
      if (error) throw new Error('Discord auth error: ' + error)
      if (typeof DISCORD_REDIRECT_URL !== 'string') return

      if (!code && !success && !error) {
        window.location.href = DISCORD_REDIRECT_URL
        return
      }
    } catch (err) {
      console.error(err)
      toast.error(err.message ?? 'There was an error connecting to Discord')
      window.location.href = '/account'
    }
  }, [history, verifyAndRedirect])

  return (
    <FullPageContainer>
      <Box center>
        <AnimatedLoader onlyWhite />
      </Box>
    </FullPageContainer>
  )
}

export default DiscordAuth
